import useStudySession, {StudySessionProps} from "../hooks/useStudySession";
import {
    Box,
    Container,
    useMediaQuery
} from "@mui/material";
import React from "react";
import {useTheme} from "@mui/material/styles";
import {useDeck} from "../../deck-management/context/DeckContext";
import WordStudyItemView from "./WordStudyItemView";


function StudySessionView({items, words, onItemReviewed}: StudySessionProps) {

    const {
        currentTaskType,
        currentWord,
        userInput,
        onUserInputChanged,
        answerSubmitted,
        isCorrectAnswer,
        submittedAnswerHasTypo,
        submittedAnswerInDontRejectWords,
        revealCorrectAnswer,
        submitAnswer,
        toggleRevealAnswer,
        handleIntentionalFail,
        nextItem,
        undo,
        reshuffle,
        allItemsFinished
    } = useStudySession({items, words, onItemReviewed});

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const {currentDeck} = useDeck();

    const mainInputRef = React.useRef<HTMLInputElement>(null);

    document.onkeydown = function (e) {
        if (!currentTaskType)
            return;
        if (e.key === 'Enter')
            answerSubmitted ? nextItem() : submitAnswer()
        else if (e.key === 'Backspace' && (answerSubmitted || submittedAnswerInDontRejectWords))
            undo();
        else if (e.key === 'f' && answerSubmitted)
            toggleRevealAnswer();
        else if (e.key === 'Tab') {
            e.preventDefault();
            if (!answerSubmitted)
                reshuffle();
        }
    };

    const undoAndFocus = () => {
        undo();
        mainInputRef.current?.focus();
    }

    const nextItemAndFocus = () => {
        nextItem();
        mainInputRef.current?.focus();
    }

    return (
        <Container disableGutters
                   maxWidth={false}
                   sx={{height: '100vh', display: "flex", flexDirection: "column", alignItems: "center", position: "relative", bgcolor: theme.palette.background.default}}>

            <Box sx={{mt: isMobile ? 8 : 8, width: isMobile ? '100%' : 700, px: 2}}>
                {contentView()}
            </Box>
        </Container>
    )

    function contentView() {
        if (allItemsFinished) {
            return null;
        } else if (currentTaskType === "translation" || currentTaskType === "recollection") {
            return reviewExerciseView();
        } else {
            return <div>Unsupported task type: {currentTaskType}</div>;
        }
    }

    function reviewExerciseView() {
        return (
            <WordStudyItemView currentWord={currentWord}
                               currentTaskType={currentTaskType}
                               language={currentDeck?.language}
                               userInput={userInput}
                               onUserInputChanged={onUserInputChanged}
                               answerSubmitted={answerSubmitted}
                               isCorrectAnswer={isCorrectAnswer}
                               submittedAnswerHasTypo={submittedAnswerHasTypo}
                               submitAnswer={submitAnswer}
                               revealCorrectAnswer={revealCorrectAnswer}
                               toggleRevealAnswer={toggleRevealAnswer}
                               handleIntentionalFail={handleIntentionalFail}
                               nextItem={nextItemAndFocus}
                               undo={undoAndFocus}
                               reshuffle={reshuffle}
                               ref={mainInputRef}
            />
        )
    }
}

export default StudySessionView;
